import { render } from "./App.vue?vue&type=template&id=d8be1a38&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=d8be1a38&scoped=true&lang=css"

import exportComponent from "/tmp/eb47f32b-990a-42a6-a461-0a5e6cce3094/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8be1a38"]])

export default __exports__